import { BASE_URL } from "../static/constants";
import { transmissionTableApi } from "app/store/transmission/api/transmissionTableApi";
const SET_USER_ACTIVE_DATA = "SET_USER_ACTIVE_DATA";

function setUserActiveData(data) {
  return {
    type: SET_USER_ACTIVE_DATA,
    data,
  };
}

export function disableUser(userId) {
  const payload = {
    userId,
  };
  return function (dispatch) {
    const token = localStorage.getItem("authToken");
    return fetch(`${BASE_URL}/admin/user/deactivate`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((result) => {
        dispatch(transmissionTableApi.util.invalidateTags(["physicians"]));
        return dispatch(setUserActiveData(result));
      })
      .catch((error) => {
        console.error("error");
      });
  };
}

export function enableUser(userId) {
  const payload = {
    userId,
  };
  return function (dispatch) {
    const token = localStorage.getItem("authToken");
    return fetch(`${BASE_URL}/admin/user/activate`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((result) => {
        dispatch(transmissionTableApi.util.invalidateTags(["physicians"]));
        return dispatch(setUserActiveData(result));
      })
      .catch((error) => {
        console.error("error");
      });
  };
}
